import React from "react";
import ReportTableSectionRenderer from "../../../../../../libraries/ReportGenerator";
import { getOtherActivityTable, getSupportingDocuments, titleOfReport } from "../CommonFunctions";
import { AirBrakeReportCSchema } from "./AirBrakeReportSys4Lvl3Schema";

function CLMB_AirBrakeReportSys4lvl3(props) {
  const { singleReport } = props;

  return (
    <div>
      <span className="spacer"></span>
      <div style={{ textAlign: "center" }}>
        <h2 style={{ fontWeight: "bolder" }}>{titleOfReport(singleReport.testCode) || singleReport.title}</h2>
      </div>
      <table className="table-bordered">
        {AirBrakeReportCSchema.airBrakeSystemParts.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {AirBrakeReportCSchema.airBrakeSystemTests.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>

      {Object.keys(singleReport.summary).includes("otherActivity") && getOtherActivityTable(singleReport.summary)}
      {Object.keys(singleReport.summary).includes("supportingDocuments") && getSupportingDocuments(singleReport.summary)}
    </div>
  );
}

export default CLMB_AirBrakeReportSys4lvl3;



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/AirBrakeReports/AirBrakeReports/CLMB/AirBrakeReportSys4Lvl3.jsx